/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import Accordion from '../components/Accordion';
import BannerImage from '../components/BannerImage';
import BannerNextStep from '../components/BannerNextStep';
import BannerText from '../components/BannerText';
import Brands from '../components/Brands';
import ButtonCta from '../components/ButtonCta';
import CarouselProjects from '../components/CarouselProjects';
import CarouselTiles from '../components/CarouselTiles';
import CaseStudiesBox from '../components/CaseStudiesBox';
import CaseStudyMobileVisual from '../components/CaseStudyMobileVisual';
import CaseStudyShortInfo from '../components/CaseStudyShortInfo';
import ColorTiles from '../components/ColorTiles';
import ContactPopup from '../components/ContactPopup';
import ContactSection from '../components/ContactSection';
import ContactTiles from '../components/ContactTiles';
import ContentBlock from '../components/ContentBlock';
import ContentTwoCols from '../components/ContentTwoCols';
import Cookies from '../components/Cookies';
import DeliverablesSection from '../components/DeliverablesSection';
import DescriptionSection from '../components/DescriptionSection';
import Divider from '../components/Divider';
import ExpertsTiles from '../components/ExpertsTiles';
import FeaturedText from '../components/FeaturedText';
import FlagCorner from '../components/FlagCorner';
import FlyingCTA from '../components/FlyingCTA';
import Footer from '../components/Footer';
import Form from '../components/Form';
import FormContact from '../components/FormContact';
import GalleryPeople from '../components/GalleryPeople';
import GraphQLConnectedDemo from '../components/GraphQL-ConnectedDemo';
import GraphQLIntegratedDemo from '../components/GraphQL-IntegratedDemo';
import GraphQLLayout from '../components/GraphQL-Layout';
import HeadingImage from '../components/HeadingImage';
import IconsGroup from '../components/IconsGroup';
import IconsTexts from '../components/IconsTexts';
import ImageBgAnimated from '../components/ImageBgAnimated';
import ImageBlock from '../components/ImageBlock';
import ImagesGrid from '../components/ImagesGrid';
import ImageText from '../components/ImageText';
import ImageTextSlider from '../components/ImageTextSlider';
import ImageTextTiles from '../components/ImageTextTiles';
import IntroBanner from '../components/IntroBanner';
import IntroBannerCta from '../components/IntroBannerCta';
import IntroBannerImage from '../components/IntroBannerImage';
import IntroBannerProductDeliveryProcess from '../components/IntroBannerProductDeliveryProcess';
import IntroText from '../components/IntroText';
import MainSlider from '../components/MainSlider';
import Navigation from '../components/Navigation';
import OffersTiles from '../components/OffersTiles';
import ProductDeliveryProcess from '../components/ProductDeliveryProcess';
import RawHTML from '../components/RawHTML';
import ReferenceBox from '../components/ReferenceBox';
import ResultsNumbers from '../components/ResultsNumbers';
import ScopeWorkProject from '../components/ScopeWorkProject';
import StyleguideComponentParams from '../components/Styleguide-ComponentParams';
import StyleguideCustomRouteType from '../components/Styleguide-CustomRouteType';
import StyleguideFieldUsageCheckbox from '../components/Styleguide-FieldUsage-Checkbox';
import StyleguideFieldUsageContentList from '../components/Styleguide-FieldUsage-ContentList';
import StyleguideFieldUsageCustom from '../components/Styleguide-FieldUsage-Custom';
import StyleguideFieldUsageDate from '../components/Styleguide-FieldUsage-Date';
import StyleguideFieldUsageFile from '../components/Styleguide-FieldUsage-File';
import StyleguideFieldUsageImage from '../components/Styleguide-FieldUsage-Image';
import StyleguideFieldUsageItemLink from '../components/Styleguide-FieldUsage-ItemLink';
import StyleguideFieldUsageLink from '../components/Styleguide-FieldUsage-Link';
import StyleguideFieldUsageNumber from '../components/Styleguide-FieldUsage-Number';
import StyleguideFieldUsageRichText from '../components/Styleguide-FieldUsage-RichText';
import StyleguideFieldUsageText from '../components/Styleguide-FieldUsage-Text';
import StyleguideLayout from '../components/Styleguide-Layout';
import StyleguideLayoutReuse from '../components/Styleguide-Layout-Reuse';
import StyleguideLayoutTabs from '../components/Styleguide-Layout-Tabs';
import StyleguideLayoutTabsTab from '../components/Styleguide-Layout-Tabs-Tab';
import StyleguideMultilingual from '../components/Styleguide-Multilingual';
import StyleguideRouteFields from '../components/Styleguide-RouteFields';
import StyleguideSection from '../components/Styleguide-Section';
import StyleguideSitecoreContext from '../components/Styleguide-SitecoreContext';
import StyleguideTracking from '../components/Styleguide-Tracking';
import TextsColumns from '../components/TextsColumns';
import TouchCTA from '../components/TouchCTA';

const components = new Map();
components.set('Accordion', Accordion);
components.set('BannerImage', BannerImage);
components.set('BannerNextStep', BannerNextStep);
components.set('BannerText', BannerText);
components.set('Brands', Brands);
components.set('ButtonCta', ButtonCta);
components.set('CarouselProjects', CarouselProjects);
components.set('CarouselTiles', CarouselTiles);
components.set('CaseStudiesBox', CaseStudiesBox);
components.set('CaseStudyMobileVisual', CaseStudyMobileVisual);
components.set('CaseStudyShortInfo', CaseStudyShortInfo);
components.set('ColorTiles', ColorTiles);
components.set('ContactPopup', ContactPopup);
components.set('ContactSection', ContactSection);
components.set('ContactTiles', ContactTiles);
components.set('ContentBlock', ContentBlock);
components.set('ContentTwoCols', ContentTwoCols);
components.set('Cookies', Cookies);
components.set('DeliverablesSection', DeliverablesSection);
components.set('DescriptionSection', DescriptionSection);
components.set('Divider', Divider);
components.set('ExpertsTiles', ExpertsTiles);
components.set('FeaturedText', FeaturedText);
components.set('FlagCorner', FlagCorner);
components.set('FlyingCTA', FlyingCTA);
components.set('Footer', Footer);
components.set('Form', Form);
components.set('FormContact', FormContact);
components.set('GalleryPeople', GalleryPeople);
components.set('GraphQL-ConnectedDemo', GraphQLConnectedDemo);
components.set('GraphQL-IntegratedDemo', GraphQLIntegratedDemo);
components.set('GraphQL-Layout', GraphQLLayout);
components.set('HeadingImage', HeadingImage);
components.set('IconsGroup', IconsGroup);
components.set('IconsTexts', IconsTexts);
components.set('ImageBgAnimated', ImageBgAnimated);
components.set('ImageBlock', ImageBlock);
components.set('ImagesGrid', ImagesGrid);
components.set('ImageText', ImageText);
components.set('ImageTextSlider', ImageTextSlider);
components.set('ImageTextTiles', ImageTextTiles);
components.set('IntroBanner', IntroBanner);
components.set('IntroBannerCta', IntroBannerCta);
components.set('IntroBannerImage', IntroBannerImage);
components.set('IntroBannerProductDeliveryProcess', IntroBannerProductDeliveryProcess);
components.set('IntroText', IntroText);
components.set('MainSlider', MainSlider);
components.set('Navigation', Navigation);
components.set('OffersTiles', OffersTiles);
components.set('ProductDeliveryProcess', ProductDeliveryProcess);
components.set('RawHTML', RawHTML);
components.set('ReferenceBox', ReferenceBox);
components.set('ResultsNumbers', ResultsNumbers);
components.set('ScopeWorkProject', ScopeWorkProject);
components.set('Styleguide-ComponentParams', StyleguideComponentParams);
components.set('Styleguide-CustomRouteType', StyleguideCustomRouteType);
components.set('Styleguide-FieldUsage-Checkbox', StyleguideFieldUsageCheckbox);
components.set('Styleguide-FieldUsage-ContentList', StyleguideFieldUsageContentList);
components.set('Styleguide-FieldUsage-Custom', StyleguideFieldUsageCustom);
components.set('Styleguide-FieldUsage-Date', StyleguideFieldUsageDate);
components.set('Styleguide-FieldUsage-File', StyleguideFieldUsageFile);
components.set('Styleguide-FieldUsage-Image', StyleguideFieldUsageImage);
components.set('Styleguide-FieldUsage-ItemLink', StyleguideFieldUsageItemLink);
components.set('Styleguide-FieldUsage-Link', StyleguideFieldUsageLink);
components.set('Styleguide-FieldUsage-Number', StyleguideFieldUsageNumber);
components.set('Styleguide-FieldUsage-RichText', StyleguideFieldUsageRichText);
components.set('Styleguide-FieldUsage-Text', StyleguideFieldUsageText);
components.set('Styleguide-Layout', StyleguideLayout);
components.set('Styleguide-Layout-Reuse', StyleguideLayoutReuse);
components.set('Styleguide-Layout-Tabs', StyleguideLayoutTabs);
components.set('Styleguide-Layout-Tabs-Tab', StyleguideLayoutTabsTab);
components.set('Styleguide-Multilingual', StyleguideMultilingual);
components.set('Styleguide-RouteFields', StyleguideRouteFields);
components.set('Styleguide-Section', StyleguideSection);
components.set('Styleguide-SitecoreContext', StyleguideSitecoreContext);
components.set('Styleguide-Tracking', StyleguideTracking);
components.set('TextsColumns', TextsColumns);
components.set('TouchCTA', TouchCTA);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
